(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@openhps/core"));
	else if(typeof define === 'function' && define.amd)
		define("OpenHPS", ["core"], factory);
	else if(typeof exports === 'object')
		exports["OpenHPS"] = factory(require("@openhps/core"));
	else
		root["OpenHPS"] = root["OpenHPS"] || {}, root["OpenHPS"]["video"] = factory(root["OpenHPS"]["core"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__955__) => {
return 